import { useState } from 'react';
import { ReportingFilter } from '../api';

export default () => {
  const [filter, setFilter] = useState<ReportingFilter>({
    department_ids: [],
    location_ids: [],
    segment_ids: [],
    group_ids: [],
  });

  return {
    filter,
    setFilter,
  };
};
